export default __webpack_public_path__ + "static/media/play.c0a9fbaf.svg";